import React from 'react'
import './index.less'
class InvestRecord extends React.Component {
    render () {
        const { buriedPointEvent, data: { id, position, sublist, trackId, style }, isLogin, handleRecord } = this.props
        return (
            <div
                className='investRecordContainer statistics-dom'
                style={{ background: style.backgroundColor || '#2B0E0E', color: style.textColor || '#fff' }}
                onClick={() => {
                    buriedPointEvent({
                        button_name: `${trackId}`,
                        button_id: `${id}`,
                        button_order: '1',
                        area_order: position,
                        button_area: `${position}-${trackId}`
                    })
                    handleRecord(sublist[0])
                }}
            >
                {sublist[0].isShowLoginEntry && !isLogin && (<span>立即登录</span>)}
                {!sublist[0].isShowLoginEntry && (<span>{sublist[0].buttonText}</span>)}
                {sublist[0].isShowLoginEntry && isLogin && (<span>{sublist[0].buttonText}</span>)}
            </div>
        )
    }
}

export default InvestRecord
